// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Contenedor principal */
.cont-profileinfo {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
    /* height: 100vh; */
    margin-bottom: 10px;
  }
  
  .list-group-profile{
    margin: auto;
  }
  
  /* Sección de imagen de perfil */
  .cont-imgprofile {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 10px;
  }
  
  .cont-imgprofile p {
    width: 100%;
    text-align: center; /* Centrar el texto */
    margin-bottom: 10px; /* Agregamos espacio entre el párrafo y la imagen */
  }
  
  .selectimage {
    display: flex;
    align-items: center;
  }
  
  .selectimage img {
    width: 80px;
    height: 80px; /* Mantenemos un tamaño cuadrado para la imagen de perfil */
    border-radius: 50%;
    overflow: hidden;
  }
  
  .overlay-button {
    background-color: transparent;
    border: none;
    cursor: pointer;
  }
  
  /* Lista de información */
  .list-group {
    display: flex;
    justify-content: space-between;
    width: 500px;
    max-width: 100%; 
    padding: 15px;
    border: 1px solid #e6e9ed;
    box-shadow: 1px 2px 8px 2px rgba(0, 0, 0, 0.24);
    -webkit-box-shadow: 1px 2px 8px 2px rgba(0, 0, 0, 0.24);
    -moz-box-shadow: 1px 2px 8px 2px rgba(0, 0, 0, 0.24);
  }
  
  .list-group p {
    font-weight: 600;
    margin-bottom: 5px;
  }
  
  .list-group-profile li {
    width: 80%; 
    padding: 5px 0;
  }
  

  .ind-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%; 
    padding-bottom: 5px;
  }
  
  .list-group-item {
    color: #73879c;
  }

  .list-companies{
    display: flex;
    flex-direction: column;
    width: 600px;
  }
  
  /* Media Queries para tamaños de pantalla más pequeños */
  @media screen and (max-width: 768px) {
    .cont-profileinfo {
      padding: 5px;
    }
  
    .list-group {
      flex-direction: column;
    }
  
    .list-group p {
      text-align: left;
    }
  
    .list-group-profile li {
      width: 85%;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/Profile/Profile.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA,gCAAgC;EAChC;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,kBAAkB,EAAE,qBAAqB;IACzC,mBAAmB,EAAE,mDAAmD;EAC1E;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY,EAAE,2DAA2D;IACzE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;IAC7B,YAAY;IACZ,eAAe;EACjB;;EAEA,yBAAyB;EACzB;IACE,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,eAAe;IACf,aAAa;IACb,yBAAyB;IACzB,+CAA+C;IAC/C,uDAAuD;IACvD,oDAAoD;EACtD;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,cAAc;EAChB;;;EAGA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;;EAEA,wDAAwD;EACxD;IACE;MACE,YAAY;IACd;;IAEA;MACE,sBAAsB;IACxB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,UAAU;IACZ;EACF","sourcesContent":["/* Contenedor principal */\n.cont-profileinfo {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 10px;\n    /* height: 100vh; */\n    margin-bottom: 10px;\n  }\n  \n  .list-group-profile{\n    margin: auto;\n  }\n  \n  /* Sección de imagen de perfil */\n  .cont-imgprofile {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-bottom: 10px;\n  }\n  \n  .cont-imgprofile p {\n    width: 100%;\n    text-align: center; /* Centrar el texto */\n    margin-bottom: 10px; /* Agregamos espacio entre el párrafo y la imagen */\n  }\n  \n  .selectimage {\n    display: flex;\n    align-items: center;\n  }\n  \n  .selectimage img {\n    width: 80px;\n    height: 80px; /* Mantenemos un tamaño cuadrado para la imagen de perfil */\n    border-radius: 50%;\n    overflow: hidden;\n  }\n  \n  .overlay-button {\n    background-color: transparent;\n    border: none;\n    cursor: pointer;\n  }\n  \n  /* Lista de información */\n  .list-group {\n    display: flex;\n    justify-content: space-between;\n    width: 500px;\n    max-width: 100%; \n    padding: 15px;\n    border: 1px solid #e6e9ed;\n    box-shadow: 1px 2px 8px 2px rgba(0, 0, 0, 0.24);\n    -webkit-box-shadow: 1px 2px 8px 2px rgba(0, 0, 0, 0.24);\n    -moz-box-shadow: 1px 2px 8px 2px rgba(0, 0, 0, 0.24);\n  }\n  \n  .list-group p {\n    font-weight: 600;\n    margin-bottom: 5px;\n  }\n  \n  .list-group-profile li {\n    width: 80%; \n    padding: 5px 0;\n  }\n  \n\n  .ind-info {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%; \n    padding-bottom: 5px;\n  }\n  \n  .list-group-item {\n    color: #73879c;\n  }\n\n  .list-companies{\n    display: flex;\n    flex-direction: column;\n    width: 600px;\n  }\n  \n  /* Media Queries para tamaños de pantalla más pequeños */\n  @media screen and (max-width: 768px) {\n    .cont-profileinfo {\n      padding: 5px;\n    }\n  \n    .list-group {\n      flex-direction: column;\n    }\n  \n    .list-group p {\n      text-align: left;\n    }\n  \n    .list-group-profile li {\n      width: 85%;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
